import React from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaFacebookF,  FaInstagram, FaLinkedin } from 'react-icons/fa';

const Bar = () => {
  return (
    <nav className="navbar">
      {/* Left side: Email and Location */}
      <div className="navbar-left1">
        <div className="navbar-item1">
          <FaEnvelope /> <span>info@smartstonemarble.com</span>
        </div>
        <div  className="navbar-item1">
          <FaMapMarkerAlt  /> <span >
          <a
          style={{textDecorationLine:"none",color:"#333"}}
            href="https://maps.app.goo.gl/uuKHTMKRnHrHs7EH6"
            target="_blank"
            rel="noopener noreferrer"
          >
            
           Al Sajaah,Sharjah</a></span>
        </div>
      </div>

      {/* Right side: Social Media Icons */}
      <div className="navbar-right">
        <a href="https://facebook.com" target="_blank" rel="noreferrer">
          <FaFacebookF className="social-icon" />
        </a>
       
        <a href="https://instagram.com" target="_blank" rel="noreferrer">
          <FaInstagram className="social-icon" />
        </a>
        <a href="https://linkedin.com" target="_blank" rel="noreferrer">
          <FaLinkedin className="social-icon" />
        </a>
      </div>
    </nav>
  );
};

export default Bar;
